import React from "react";
import styled from "styled-components";
import { H5, H4 } from "storybook-components/Typography";
import NotchedImg from "./PostPreviewCards/NotchedImg";
import BlogArticleLink from "./BlogArticleLink";

const MobileFriendlyFlexContainer = styled.div`
  display: flex;
  ${props => props.theme.media.desktopUp`
    width: 100%;
  `};
`;

const ContinueWrapper = styled.div`
  display: flex;
  margin-bottom: 24px;
`;

const RelatedArticlesWrapper = styled.div`
  margin: 80px 16px 10px 16px;
  padding: 16px 0;
  ${props => props.theme.media.desktopUp`
    margin: 128px 0 10px 0;
  `};
`;

const Card = styled.div`
  display: flex;
  flex-direction: column;
  background-color: ${({ theme }) => theme.colors.green1};
  border-radius: 10px;
  overflow: hidden;
  &:hover {
    .text-area {
      background-color: ${({ theme }) => theme.colors.green4};
    }
    .text {
      color: ${({ theme }) => theme.colors.gray1};
    }
  }
`;

const RelatedArticleLink = styled(BlogArticleLink)`
  display: block;
  text-decoration: none;
  margin: auto 8px;
  width: 50%;
  ${props => props.theme.media.tabletUp`
    margin: 0 24px 0 0;
  `};
`;

const CardTextArea = styled.div`
  min-height: 200px;
  padding: 16px 8px;
  ${props => props.theme.media.desktopUp`
    padding: 32px;
  `};
`;

const StyledNotchedImage = styled(NotchedImg)`
  margin-bottom: 16px;
  width: 100%;
  object-fit: cover;
`;

const StyledText = styled(H5)`
  margin: 0;
  color: ${({ theme }) => theme.colors.green5};
`;

const checkHeroImage = (node, heroImage) => {
  if (heroImage) {
    return (
      <StyledNotchedImage
        imageData={node.heroImage.gatsbyImageData}
        alt={node.heroImage.title}
      />
    );
  }
  return <StyledNotchedImage alt="no-hero-image" />;
};

export default props => {
  const { relatedArticles } = props;
  return (
    <RelatedArticlesWrapper>
      <ContinueWrapper>
        <H4>Related Articles</H4>
      </ContinueWrapper>
      <MobileFriendlyFlexContainer>
        {relatedArticles.map(post => (
          <RelatedArticleLink to={post.node.slug}>
            <Card key={post.node.slug}>
              {checkHeroImage(post.node, post.node.heroImage)}
              <CardTextArea className="text-area">
                <StyledText className="text">{post.node.title}</StyledText>
              </CardTextArea>
            </Card>
          </RelatedArticleLink>
        ))}
      </MobileFriendlyFlexContainer>
    </RelatedArticlesWrapper>
  );
};
